import { Theme, createTheme } from "@mui/material/styles";

import { SupportedLanguage } from "@/i18n";

import { LightTheme, WidgetTheme } from "./themes/LightTheme";

const themeMap: Record<string, (...args: object[]) => Theme> = {
  LightTheme,
  WidgetTheme,
};

export function themeCreator(theme: string, language: SupportedLanguage): Theme {
  const createdTheme = themeMap[theme];
  const themeArgs: object[] = [
    ...(language.dataGridLocalization ? [language.dataGridLocalization] : []),
    ...(language.xDatePickersLocale ? [language.xDatePickersLocale] : []),
    ...(language.muiLocalization ? [language.muiLocalization] : []),
  ];

  if (createdTheme) return createdTheme(...themeArgs);
  return createTheme(undefined, themeArgs);
}
